import React from 'react'
import './index.css';
import Property4 from '../../../component/Explore/Propertypage'

const Property = () => {
  return (
    <div>
      <Property4 num="+91-2934572" type="Family Rustic Room" desc="Come and enjoy the experience of a family rustic room with your family. Enjoy the vibe of a vibrant weather and a cosy location." roomdesc = "Pre-Book Your room for your partner , family or friends to enjoy the seamless checkin." price = "1700" guests="2" bed="4"  bath="2"/>
    </div>
  )
}

export default Property
